import { render } from "./QuoteProductsList.vue?vue&type=template&id=ad1c837a"
import script from "./QuoteProductsList.vue?vue&type=script&lang=js"
export * from "./QuoteProductsList.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/data/dev.bl8m.it/vhosts/clients/client0/web144/web/shops/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__